import { Analytics } from '@cobliteam/analytics';
import BaseButton from '@cobliteam/colib-ui/Button';
import Icon, { type IconNames } from '@cobliteam/ui/icons';
import type { ComponentProps } from 'react';
import { useHistory } from 'react-router-dom';
import { isFilled, type KeyTextField } from '../index';
import type { LoginPageDocumentDataButtonsItem } from '../types/herbie-dashboard.generated';

type ButtonProps = ComponentProps<typeof BaseButton>;

type PrismicButtonType = ButtonProps & {
  button: LoginPageDocumentDataButtonsItem;
  idx?: number;
  analytics_track?: KeyTextField;
};

// O Prismic ainda cadastra variant/color/size do @cobliteam/ui; traduz para o Button do colib-ui.
const VARIANT_BY_PRISMIC: Record<string, ButtonProps['variant']> = {
  surface: 'secondary',
  contained: 'default',
  outlined: 'outline',
  text: 'ghost',
  link: 'link',
  ghost: 'ghost',
};

function toColibVariant(variant: string | null, color: string | null): ButtonProps['variant'] {
  if (color === 'danger' || color === 'danger-dark') return variant === 'surface' ? 'secondary' : 'destructive';
  if (variant === 'contained' && color === 'default') return 'secondary';
  return VARIANT_BY_PRISMIC[variant ?? 'contained'] ?? 'default';
}

export function PrismicButton({ button, idx, analytics_track }: PrismicButtonType) {
  const history = useHistory();

  const handleClick = () => {
    analytics_track && Analytics.track(analytics_track);
    isFilled.link(button.link) &&
      button.link.link_type === 'Web' &&
      (button.link.target === '_blank' ? window.open(button.link.url, button.link.target) : history.push(button.link.url));
  };

  return (
    <BaseButton
      key={idx}
      variant={toColibVariant(button.variant, button.color)}
      size={button.size === 'sm' || button.size === 'condensed' ? 'sm' : 'default'}
      onClick={handleClick}
    >
      {isFilled.select(button.left_icon) && <Icon name={button.left_icon as IconNames} />}
      {button.label}
      {isFilled.select(button.right_icon) && <Icon name={button.right_icon as IconNames} />}
    </BaseButton>
  );
}
